import { EnrollmentHealthInput } from '../../lib/types/models/enrollment/enrollment-health'
import { UpdateInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function updateEnrollmentHealth({ id, ...data }: UpdateInput<EnrollmentHealthInput>) {
  return restApiClient
    .url(constructApiUrl(API.enrollments.updateEnrollmentHealth.url, { id }))
    .patch<unknown, EnrollmentHealthInput>(data)
}
